export default{

    apiUrl: '/api'
};
